import Vue from "vue";
import { ToastPosition } from "vue-toasted";
import AxiosErrorsMapper from "./axiosErrorsMapper";

export function showToast(
  message: string,
  config: { position?: string; type?: string; duration?: number } = {
    position: "top-right",
    type: "success",
  }
) {
  Vue.toasted.show(message, {
    position: config.position || "top-right",
    type: config.type || "success",
    duration: config.duration || 1500,
    keepOnHover: true,
  } as any);
}

export function responseErrorMessage(error: unknown): string | null {
  return (
    (error as { response?: { data?: { message?: string } } })?.response?.data
      ?.message ?? null
  );
}

class ToastInvoker {
  successToast(message: string, position?: "top-right", duration?: number) {
    Vue.toasted.success(message, {
      position: position || "top-right",
      duration: duration || 1500,
    });
  }

  errorToast(
    message: string | null,
    error: any | null,
    position?: ToastPosition,
    duration?: number
  ) {
    let messageToEmit = "";

    if (!message) {
      const axiosErrorsMapper = new AxiosErrorsMapper();
      messageToEmit = axiosErrorsMapper.translateError(error);
    } else {
      messageToEmit = message;
    }

    const toast = Vue.toasted.error(messageToEmit, {
      position: position || "top-right",
      duration: duration ?? 15000,
      keepOnHover: true,
      className: "toasted--dismissable",
    } as any);

    toast.el.addEventListener("click", () => toast.goAway(0));
  }
}

export default new ToastInvoker();
